import { Routes } from '@angular/router';

export const personalInformationRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./personal-information-view/personal-information-view.component').then(
        (m) => m.PersonalInformationViewComponent,
      ),
    data: {
      shouldShowTabBar: false,
    },
  },
  {
    path: 'edit',
    loadComponent: () =>
      import('./personal-information-edit/personal-information-edit.component').then(
        (m) => m.PersonalInformationEditComponent,
      ),
    data: {
      shouldShowTabBar: false,
    },
  },
  {
    path: 'review-changes',
    loadComponent: () =>
      import('./personal-information-review/personal-information-review.component').then(
        (m) => m.PersonalInformationReviewComponent,
      ),
    data: {
      shouldShowTabBar: false,
    },
  },
];
